// Estadias mensalistas (acima de 26 noites) tem condominio, IPTU, limpezas e pacote
// embutidos no valor da reserva. Esses itens sao tratados em contrato com o proprietario
// (podem ser dedutiveis de IR) e nao entram nos relatorios, entao o site so os detalha
// a partir desta quantidade de noites. Abaixo disso, mostra um valor unico.
export const MIN_NIGHTS_TO_SHOW_FEE_BREAKDOWN = 90

export const shouldShowFeeBreakdown = (nights: number): boolean => {
    return nights >= MIN_NIGHTS_TO_SHOW_FEE_BREAKDOWN
}
